"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.openFiles = exports.loopFiles = exports.idleSequence = void 0;
var Box_Idle_00000_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00000.jpg"));
var Box_Idle_00001_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00001.jpg"));
var Box_Idle_00002_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00002.jpg"));
var Box_Idle_00003_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00003.jpg"));
var Box_Idle_00004_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00004.jpg"));
var Box_Idle_00005_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00005.jpg"));
var Box_Idle_00006_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00006.jpg"));
var Box_Idle_00007_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00007.jpg"));
var Box_Idle_00008_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00008.jpg"));
var Box_Idle_00009_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00009.jpg"));
var Box_Idle_00010_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00010.jpg"));
var Box_Idle_00011_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00011.jpg"));
var Box_Idle_00012_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00012.jpg"));
var Box_Idle_00013_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00013.jpg"));
var Box_Idle_00014_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00014.jpg"));
var Box_Idle_00015_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00015.jpg"));
var Box_Idle_00016_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00016.jpg"));
var Box_Idle_00017_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00017.jpg"));
var Box_Idle_00018_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00018.jpg"));
var Box_Idle_00019_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00019.jpg"));
var Box_Idle_00020_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00020.jpg"));
var Box_Idle_00021_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00021.jpg"));
var Box_Idle_00022_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00022.jpg"));
var Box_Idle_00023_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00023.jpg"));
var Box_Idle_00024_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00024.jpg"));
var Box_Idle_00025_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00025.jpg"));
var Box_Idle_00026_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00026.jpg"));
var Box_Idle_00027_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00027.jpg"));
var Box_Idle_00028_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00028.jpg"));
var Box_Idle_00029_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00029.jpg"));
var Box_Idle_00030_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00030.jpg"));
var Box_Idle_00031_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00031.jpg"));
var Box_Idle_00032_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00032.jpg"));
var Box_Idle_00033_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00033.jpg"));
var Box_Idle_00034_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00034.jpg"));
var Box_Idle_00035_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00035.jpg"));
var Box_Idle_00036_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00036.jpg"));
var Box_Idle_00037_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00037.jpg"));
var Box_Idle_00038_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00038.jpg"));
var Box_Idle_00039_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00039.jpg"));
var Box_Idle_00040_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00040.jpg"));
var Box_Idle_00041_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00041.jpg"));
var Box_Idle_00042_jpg_1 = __importDefault(require("../../assets/lootBox/Idle/Box-Idle_00042.jpg"));
var Box_Loop_00049_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00049.jpg"));
var Box_Loop_00050_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00050.jpg"));
var Box_Loop_00051_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00051.jpg"));
var Box_Loop_00052_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00052.jpg"));
var Box_Loop_00053_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00053.jpg"));
var Box_Loop_00054_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00054.jpg"));
var Box_Loop_00055_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00055.jpg"));
var Box_Loop_00056_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00056.jpg"));
var Box_Loop_00057_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00057.jpg"));
var Box_Loop_00058_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00058.jpg"));
var Box_Loop_00059_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00059.jpg"));
var Box_Loop_00060_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00060.jpg"));
var Box_Loop_00061_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00061.jpg"));
var Box_Loop_00062_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00062.jpg"));
var Box_Loop_00063_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00063.jpg"));
var Box_Loop_00064_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00064.jpg"));
var Box_Loop_00065_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00065.jpg"));
var Box_Loop_00066_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00066.jpg"));
var Box_Loop_00067_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00067.jpg"));
var Box_Loop_00068_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00068.jpg"));
var Box_Loop_00069_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00069.jpg"));
var Box_Loop_00070_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00070.jpg"));
var Box_Loop_00071_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00071.jpg"));
var Box_Loop_00072_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00072.jpg"));
var Box_Loop_00073_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00073.jpg"));
var Box_Loop_00074_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00074.jpg"));
var Box_Loop_00075_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00075.jpg"));
var Box_Loop_00076_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00076.jpg"));
var Box_Loop_00077_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00077.jpg"));
var Box_Loop_00078_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00078.jpg"));
var Box_Loop_00079_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00079.jpg"));
var Box_Loop_00080_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00080.jpg"));
var Box_Loop_00081_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00081.jpg"));
var Box_Loop_00082_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00082.jpg"));
var Box_Loop_00083_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00083.jpg"));
var Box_Loop_00084_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00084.jpg"));
var Box_Loop_00085_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00085.jpg"));
var Box_Loop_00086_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00086.jpg"));
var Box_Loop_00087_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00087.jpg"));
var Box_Loop_00088_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00088.jpg"));
var Box_Loop_00089_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00089.jpg"));
var Box_Loop_00090_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00090.jpg"));
var Box_Loop_00091_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00091.jpg"));
var Box_Loop_00092_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00092.jpg"));
var Box_Loop_00093_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00093.jpg"));
var Box_Loop_00094_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00094.jpg"));
var Box_Loop_00095_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00095.jpg"));
var Box_Loop_00096_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00096.jpg"));
var Box_Loop_00097_jpg_1 = __importDefault(require("../../assets/lootBox/Loop/Box-Loop_00097.jpg"));
var Box_Open_00000_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00000.jpg"));
var Box_Open_00001_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00001.jpg"));
var Box_Open_00002_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00002.jpg"));
var Box_Open_00003_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00003.jpg"));
var Box_Open_00004_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00004.jpg"));
var Box_Open_00005_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00005.jpg"));
var Box_Open_00006_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00006.jpg"));
var Box_Open_00007_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00007.jpg"));
var Box_Open_00008_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00008.jpg"));
var Box_Open_00009_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00009.jpg"));
var Box_Open_00010_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00010.jpg"));
var Box_Open_00011_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00011.jpg"));
var Box_Open_00012_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00012.jpg"));
var Box_Open_00013_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00013.jpg"));
var Box_Open_00014_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00014.jpg"));
var Box_Open_00015_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00015.jpg"));
var Box_Open_00016_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00016.jpg"));
var Box_Open_00017_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00017.jpg"));
var Box_Open_00018_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00018.jpg"));
var Box_Open_00019_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00019.jpg"));
var Box_Open_00020_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00020.jpg"));
var Box_Open_00021_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00021.jpg"));
var Box_Open_00022_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00022.jpg"));
var Box_Open_00023_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00023.jpg"));
var Box_Open_00024_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00024.jpg"));
var Box_Open_00025_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00025.jpg"));
var Box_Open_00026_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00026.jpg"));
var Box_Open_00027_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00027.jpg"));
var Box_Open_00028_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00028.jpg"));
var Box_Open_00029_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00029.jpg"));
var Box_Open_00030_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00030.jpg"));
var Box_Open_00031_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00031.jpg"));
var Box_Open_00032_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00032.jpg"));
var Box_Open_00033_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00033.jpg"));
var Box_Open_00034_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00034.jpg"));
var Box_Open_00035_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00035.jpg"));
var Box_Open_00036_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00036.jpg"));
var Box_Open_00037_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00037.jpg"));
var Box_Open_00038_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00038.jpg"));
var Box_Open_00039_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00039.jpg"));
var Box_Open_00040_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00040.jpg"));
var Box_Open_00041_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00041.jpg"));
var Box_Open_00042_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00042.jpg"));
var Box_Open_00043_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00043.jpg"));
var Box_Open_00044_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00044.jpg"));
var Box_Open_00045_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00045.jpg"));
var Box_Open_00046_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00046.jpg"));
var Box_Open_00047_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00047.jpg"));
var Box_Open_00048_jpg_1 = __importDefault(require("../../assets/lootBox/Open/Box-Open_00048.jpg"));
exports.idleSequence = {
    images: [
        Box_Idle_00000_jpg_1.default,
        Box_Idle_00001_jpg_1.default,
        Box_Idle_00002_jpg_1.default,
        Box_Idle_00003_jpg_1.default,
        Box_Idle_00004_jpg_1.default,
        Box_Idle_00005_jpg_1.default,
        Box_Idle_00006_jpg_1.default,
        Box_Idle_00007_jpg_1.default,
        Box_Idle_00008_jpg_1.default,
        Box_Idle_00009_jpg_1.default,
        Box_Idle_00010_jpg_1.default,
        Box_Idle_00011_jpg_1.default,
        Box_Idle_00012_jpg_1.default,
        Box_Idle_00013_jpg_1.default,
        Box_Idle_00014_jpg_1.default,
        Box_Idle_00015_jpg_1.default,
        Box_Idle_00016_jpg_1.default,
        Box_Idle_00017_jpg_1.default,
        Box_Idle_00018_jpg_1.default,
        Box_Idle_00019_jpg_1.default,
        Box_Idle_00020_jpg_1.default,
        Box_Idle_00021_jpg_1.default,
        Box_Idle_00022_jpg_1.default,
        Box_Idle_00023_jpg_1.default,
        Box_Idle_00024_jpg_1.default,
        Box_Idle_00025_jpg_1.default,
        Box_Idle_00026_jpg_1.default,
        Box_Idle_00027_jpg_1.default,
        Box_Idle_00028_jpg_1.default,
        Box_Idle_00029_jpg_1.default,
        Box_Idle_00030_jpg_1.default,
        Box_Idle_00031_jpg_1.default,
        Box_Idle_00032_jpg_1.default,
        Box_Idle_00033_jpg_1.default,
        Box_Idle_00034_jpg_1.default,
        Box_Idle_00035_jpg_1.default,
        Box_Idle_00036_jpg_1.default,
        Box_Idle_00037_jpg_1.default,
        Box_Idle_00038_jpg_1.default,
        Box_Idle_00039_jpg_1.default,
        Box_Idle_00040_jpg_1.default,
        Box_Idle_00041_jpg_1.default,
        Box_Idle_00042_jpg_1.default,
    ],
};
exports.loopFiles = {
    images: [
        Box_Loop_00049_jpg_1.default,
        Box_Loop_00050_jpg_1.default,
        Box_Loop_00051_jpg_1.default,
        Box_Loop_00052_jpg_1.default,
        Box_Loop_00053_jpg_1.default,
        Box_Loop_00054_jpg_1.default,
        Box_Loop_00055_jpg_1.default,
        Box_Loop_00056_jpg_1.default,
        Box_Loop_00057_jpg_1.default,
        Box_Loop_00058_jpg_1.default,
        Box_Loop_00059_jpg_1.default,
        Box_Loop_00060_jpg_1.default,
        Box_Loop_00061_jpg_1.default,
        Box_Loop_00062_jpg_1.default,
        Box_Loop_00063_jpg_1.default,
        Box_Loop_00064_jpg_1.default,
        Box_Loop_00065_jpg_1.default,
        Box_Loop_00066_jpg_1.default,
        Box_Loop_00067_jpg_1.default,
        Box_Loop_00068_jpg_1.default,
        Box_Loop_00069_jpg_1.default,
        Box_Loop_00070_jpg_1.default,
        Box_Loop_00071_jpg_1.default,
        Box_Loop_00072_jpg_1.default,
        Box_Loop_00073_jpg_1.default,
        Box_Loop_00074_jpg_1.default,
        Box_Loop_00075_jpg_1.default,
        Box_Loop_00076_jpg_1.default,
        Box_Loop_00077_jpg_1.default,
        Box_Loop_00078_jpg_1.default,
        Box_Loop_00079_jpg_1.default,
        Box_Loop_00080_jpg_1.default,
        Box_Loop_00081_jpg_1.default,
        Box_Loop_00082_jpg_1.default,
        Box_Loop_00083_jpg_1.default,
        Box_Loop_00084_jpg_1.default,
        Box_Loop_00085_jpg_1.default,
        Box_Loop_00086_jpg_1.default,
        Box_Loop_00087_jpg_1.default,
        Box_Loop_00088_jpg_1.default,
        Box_Loop_00089_jpg_1.default,
        Box_Loop_00090_jpg_1.default,
        Box_Loop_00091_jpg_1.default,
        Box_Loop_00092_jpg_1.default,
        Box_Loop_00093_jpg_1.default,
        Box_Loop_00094_jpg_1.default,
        Box_Loop_00095_jpg_1.default,
        Box_Loop_00096_jpg_1.default,
        Box_Loop_00097_jpg_1.default,
    ],
};
exports.openFiles = {
    images: [
        Box_Open_00000_jpg_1.default,
        Box_Open_00001_jpg_1.default,
        Box_Open_00002_jpg_1.default,
        Box_Open_00003_jpg_1.default,
        Box_Open_00004_jpg_1.default,
        Box_Open_00005_jpg_1.default,
        Box_Open_00006_jpg_1.default,
        Box_Open_00007_jpg_1.default,
        Box_Open_00008_jpg_1.default,
        Box_Open_00009_jpg_1.default,
        Box_Open_00010_jpg_1.default,
        Box_Open_00011_jpg_1.default,
        Box_Open_00012_jpg_1.default,
        Box_Open_00013_jpg_1.default,
        Box_Open_00014_jpg_1.default,
        Box_Open_00015_jpg_1.default,
        Box_Open_00016_jpg_1.default,
        Box_Open_00017_jpg_1.default,
        Box_Open_00018_jpg_1.default,
        Box_Open_00019_jpg_1.default,
        Box_Open_00020_jpg_1.default,
        Box_Open_00021_jpg_1.default,
        Box_Open_00022_jpg_1.default,
        Box_Open_00023_jpg_1.default,
        Box_Open_00024_jpg_1.default,
        Box_Open_00025_jpg_1.default,
        Box_Open_00026_jpg_1.default,
        Box_Open_00027_jpg_1.default,
        Box_Open_00028_jpg_1.default,
        Box_Open_00029_jpg_1.default,
        Box_Open_00030_jpg_1.default,
        Box_Open_00031_jpg_1.default,
        Box_Open_00032_jpg_1.default,
        Box_Open_00033_jpg_1.default,
        Box_Open_00034_jpg_1.default,
        Box_Open_00035_jpg_1.default,
        Box_Open_00036_jpg_1.default,
        Box_Open_00037_jpg_1.default,
        Box_Open_00038_jpg_1.default,
        Box_Open_00039_jpg_1.default,
        Box_Open_00040_jpg_1.default,
        Box_Open_00041_jpg_1.default,
        Box_Open_00042_jpg_1.default,
        Box_Open_00043_jpg_1.default,
        Box_Open_00044_jpg_1.default,
        Box_Open_00045_jpg_1.default,
        Box_Open_00046_jpg_1.default,
        Box_Open_00047_jpg_1.default,
        Box_Open_00048_jpg_1.default,
    ],
};
